import React from 'react';
import _get from 'lodash/get';
import {
  Box,
  Step,
  StepLabel,
  Stepper,
  Typography,
  makeStyles,
} from '@material-ui/core';
import { StepIconComponent } from './StepIconComponent';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    flexGrow: 1,
    marginRight: 20,
  },
  title: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'PoppinsSemiBold',
    fontSize: '1rem',
    fontStyle: 'italic',
    marginRight: 20,
    '& mark': {
      display: 'inline-flex',
      minWidth: 40,
      color: '#37BB7C',
      backgroundColor: 'transparent',
    },
  },
  root: {
    padding: 0,
    flexGrow: 1,

    '& .MuiStepConnector-completed .MuiStepConnector-line,& .MuiStepConnector-active .MuiStepConnector-line': {
      borderColor: '#37BB7C',
      borderTopWidth: 3,
    },

    '& .Mui-disabled .MuiStepConnector-line': {
      borderColor: '#ECF4F8',
    },
  },
  step: {
    padding: 0,
  },
  stepLabel: {
    '& .MuiStepLabel-iconContainer': {
      paddingRight: 0,
    },

    '&.Mui-disabled .MuiStepLabel-iconContainer': {
      padding: 0,
    },
  },
}));

export const SeriesStepper = ({ activeStep, stepsCount, seriesSiteCopy }) => {
  const classes = useStyles();
  const progress = Math.round((activeStep / stepsCount) * 100);

  return (
    <Box className={classes.container}>
      <Typography color="textPrimary" className={classes.title}>
        {_get(seriesSiteCopy, 'pageCopy.progress')} <mark>{progress}%</mark>
      </Typography>
      <Stepper activeStep={activeStep} classes={{ root: classes.root }}>
        {Array.from({ length: stepsCount + 1 }).map((_, idx) => (
          <Step key={idx} classes={{ root: classes.step }}>
            <StepLabel
              classes={{
                root: classes.stepLabel,
                iconContainer: classes.iconContainer,
              }}
              StepIconComponent={StepIconComponent}
            />
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};
